import BaseViz from './BaseViz'
import ScatterPlotChart from '../charts/ScatterPlotChart'
import ScatterDataController from '../viz_behaviors/ScatterDataController'
import { select as d3_select } from 'd3-selection'
import { encodeDate } from '@/utils/dates.js'

export default class ScatterPlotViz extends BaseViz {
  static defaultConfig = {
    sizeAttr: null,
    ItemsHelper: {
      colorScale: {
        value: 'categorical',
        options: ['categorical'], //['sequential2','sequential3','categorical']
        nonEditable: true,
      },
      colorKey: 'group',
    },
    AxisHelper: {
      x: {
        showTickValues: {
          nonEditable: true,
        },
      },
    },
    TooltipBehavior: {
      getHtml: function(d) {
        return `<div class="rows">
          <div class="row">
            <p class="important">${d.label}</p>
          </div>
          <div class="row">
            <table>
              <tr>
                <td>X Axis</td>
                <td class="important">${this.valueWithUnit(d.x, 'x')}</td>
                <td>${encodeDate(d.dates[0])}</td>
              </tr>
              <tr>
                <td>Y Axis</td>
                <td class="important">${this.valueWithUnit(d.y, 'y')}</td>
                <td>${encodeDate(d.dates[1])}</td>
              </tr>
              <tr ${this.config.sizeAttr ? '' : 'style="display: none;"'}>
                <td>Size</td>
                <td class="important">${this.valueWithUnit(d.size, 'z')}</td>
                <td>${encodeDate(d.dates[2])}</td>
              </tr>
            </table>
          </div>
        </div>`
      },
      getItemOffset: function($el) {
        let targetRect = d3_select($el)
          .select('circle')
          .node()
          .getBoundingClientRect()
        return {
          x: targetRect.x + targetRect.width / 2,
          y: targetRect.y + targetRect.height / 2 - 10,
        }
      },
    },
    LegendBehavior: {
      icon: 'circle',
    },
  }
  static chartClass = ScatterPlotChart
  static dataControllerClass = ScatterDataController
}
